import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { DeviceDetectorService } from 'ngx-device-detector';
import { HttpClientModule } from '@angular/common/http';
import { MatDialogModule, MatTooltipModule } from '@angular/material';
import { NgModule } from '@angular/core';
import { NgxSpinnerModule } from 'ngx-spinner';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BienvenidaComponent } from './pages/bienvenida/bienvenida.component';
import { CamaraControlsComponent } from './components/controls/camara-controls/camara-controls.component';
import { ConsentRecordingComponent } from './components/rec-permit/consent-recording.component';
import { ControlsComponent } from './components/controls/controls.component';
import { FinalizadoComponent } from './pages/finalizado/finalizado.component';
import { FooterComponent } from './components/footer/footer.component';
import { httpInterceptorProviders } from './interceptors';
import { PopupComponent } from './components/popup/popup.component';
import { TimerComponent } from './components/timer/timer.component';
import { TycComponent } from './components/tyc/tyc.component';
import { VideoconsultaComponent } from './pages/videoconsulta/videoconsulta.component';
import { WaitForMedicComponent } from './components/wait-for-medic/wait-for-medic.component';

@NgModule({
  declarations: [
    AppComponent,
    BienvenidaComponent,
    CamaraControlsComponent,
    ConsentRecordingComponent,
    ControlsComponent,
    FinalizadoComponent,
    FooterComponent,
    PopupComponent,
    TimerComponent,
    TycComponent,
    VideoconsultaComponent,
    WaitForMedicComponent,
  ],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    HttpClientModule,
    MatDialogModule,
    MatTooltipModule,
    NgxSpinnerModule,
  ],
  entryComponents: [ ConsentRecordingComponent, PopupComponent, TycComponent ],
  providers: [ DatePipe, DeviceDetectorService, httpInterceptorProviders ],
  bootstrap: [AppComponent],
})
export class AppModule {}
